// import api from './api';
import { apiUtils } from '../utils/api';

export const getInvoicesList = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.clientId) params.append('client', filters.clientId);
  if (filters.date) params.append('date', filters.date);
  if (filters.startDate) params.append('start_date', filters.startDate);
  if (filters.endDate) params.append('end_date', filters.endDate);

  const query = params.toString();
  const endpoint = query ? `invoices/?${query}` : 'invoices/';

  const data = await apiUtils.get(endpoint);
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
};

export const createInvoice = async (form) => {
  const payload = {
    client: form.client,
    total_amount: form.total_amount,
    is_paid: form.is_paid,
    invoice_sent: form.invoice_sent,
    invoice_datetime: form.invoice_datetime,
    billing_month: form.billing_month,
    billing_year: form.billing_year,
    description: form.description,
  };
  // apiUtils.post returns response.data already
  const data = await apiUtils.post('invoices/', payload);
  return data;
}; 


export const payInvoice = async (invoiceId) => {
  return await apiUtils.post(`invoices/${invoiceId}/pay/`);
};

export const downloadInvoicePdf = async (invoiceId, filename = `Invoice_${invoiceId}.pdf`) => {
  return await apiUtils.download(`invoices/${invoiceId}/download/`, filename);
};
